import Handler from "../Handler";

class SitOutBroadcastHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processSitOutBroadcast(receivedData);
  }
}

export default SitOutBroadcastHandler;
